
const selectors$M = {
    collectionImage: '.collection-item__image',
    columnImage: '.column__image__wrapper',
    categoryNavigatorCardImage: '.category-navigator__card-image',
    aos: '[data-aos]',
    flickityNextArrow: '.flickity-button.next',
    flickityPrevArrow: '.flickity-button.previous',
    heroContent: '.hero__content',
    heroContentWrapper: '.hero__content__wrapper',
    link: 'a:not(.hero__btn)',
    nextArrow: '[data-next-arrow]',
    prevArrow: '[data-prev-arrow]',
    productItemImage: '.product-item__image',
    slide: '[data-slide]',
    slideValue: 'data-slide',
    slider: '[data-slider]',
    sliderThumb: '[data-slider-thumb]',
    sliderThumbClick: '[data-slider-thumb-click]',
    slideshowSlideImg: '.slide-image-img',
    img: 'img.is-loading',
};

const attributes$a = {
    sliderOptions: 'data-options',
    arrowPositionMiddle: 'data-arrow-position-middle',
    aspectRatio: 'data-aspectratio',
    equalizeHeight: 'data-equalize-height',
    setHeight: 'data-set-height',
    slideIndex: 'data-slide-index',
    sliderAnimate: 'data-slider-animate',
    sliderAnimateOnce: 'data-slider-animate-once',
    slidesDesktop: 'data-slides-desktop',
    slidesLargeDesktop: 'data-slides-large-desktop',
    slidesMobileDesktop: 'data-slides-mobile',
    slidesTabletDesktop: 'data-slides-tablet',
    slideTextColor: 'data-slide-text-color',
};

const classes$D = {
    aosAnimated: 'aos-animated',
    flickityResize: 'flickity-resize',
    flickityResizing: 'flickity-resizing',
    flickityEnabled: 'flickity-enabled',
    heroContentTransparent: 'hero__content--transparent',
    isSelected: 'is-selected',
    sliderArrowsHidden: 'flickity-button-hide',
    sliderInitialized: 'js-slider--initialized',
    aosAnimate: 'aos-animate',
    focused: 'is-focused',
};

if (!customElements.get('category-slider')) {

    class CategorySlider extends HTMLElement {

        constructor() {

            super();

            this.slideshow = this.querySelector(selectors$M.slider);

            if (!this.slideshow) return;

            this.slideshowSlides = this.slideshow.querySelectorAll(selectors$M.slide);

            if (this.slideshowSlides.length <= 1) return;

            this.sliderPrev = this.querySelector(selectors$M.prevArrow);
            this.sliderNext = this.querySelector(selectors$M.nextArrow);
            this.sliderThumbs = this.querySelectorAll(selectors$M.sliderThumb);
            this.sliderThumbsClick = this.querySelectorAll(selectors$M.sliderThumbClick);
            this.multipleSlides = this.slideshow.hasAttribute(attributes$a.slidesLargeDesktop);
            this.isHeightEqualized = this.slideshow.getAttribute(attributes$a.equalizeHeight) === 'true';
            this.sliderAnimate = this.slideshow.getAttribute(attributes$a.sliderAnimate) === 'true';
            this.sliderAnimateOnce = this.slideshow.getAttribute(attributes$a.sliderAnimateOnce) === 'true';
            this.setMinHeightFlag = this.slideshow.getAttribute(attributes$a.setHeight) === 'true';

            this.sliderCallbackEventOnResize = () => this.sliderCallbackEvent();
            this.addRemoveSlidesForDevicesOnResize = () => this.addRemoveSlidesForDevices();
            this.resetSliderEvent = () => this.resetSlider();

            if (this.slideshow.hasAttribute(attributes$a.sliderOptions)) {
                this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(attributes$a.sliderOptions)));
            }


            this.flkty = null;

        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            this.onUnload();
        }

        init() {
            this.setMinHeight();

            this.sliderOptions = {
                contain: true,
                wrapAround: true,
                cellAlign: 'left',
                imagesLoaded: true,
                ...this.customOptions,
                on: {
                    ready: () => {
                        if (this.sliderAnimate && this.sliderAnimateOnce && Boolean(this.sliderOptions.autoPlay)) {
                            const currentSlide = this.slideshow.querySelector(`.${classes$D.isSelected}`);
                            currentSlide.classList.add(classes$D.aosAnimated);
                        }

                        setTimeout(() => {
                            this.slideshow.parentNode.dispatchEvent(
                                new CustomEvent('theme:slider:loaded', {
                                    bubbles: true,
                                    detail: {
                                        slider: this,
                                    },
                                })
                            );
                        }, 10);

                        this.slideActions();

                        if (this.slideshow.classList.contains(classes$D.isSelected)) {
                            this.slideshow.classList.remove(classes$D.isSelected);
                        }
                        if (this.sliderOptions.prevNextButtons) {
                            this.initArrows();
                            this.positionArrows();
                        }
                    },
                    resize: () => {
                        if (this.sliderOptions.prevNextButtons) {
                            this.positionArrows();
                        }
                    },
                },
            };

            if (this.sliderOptions.fade) {
                this.flkty = new themeVendor.FlickityFade(this.slideshow, this.sliderOptions);
            }

            if (!this.sliderOptions.fade) {
                this.flkty = new themeVendor.Flickity(this.slideshow, this.sliderOptions);
            }

            if (this.isHeightEqualized) {
                this.equalizeHeight();
            }

            if (this.sliderPrev) {
                this.sliderPrev.addEventListener('click', (e) => {
                    e.preventDefault();

                    this.flkty.previous(true);
                });
            }

            if (this.sliderNext) {
                this.sliderNext.addEventListener('click', (e) => {
                    e.preventDefault();

                    this.flkty.next(true);
                });
            }

            this.flkty.on('change', () => this.slideActions(true));

            this.addRemoveSlidesForDevices();

            document.addEventListener('theme:resize', this.addRemoveSlidesForDevicesOnResize);

            if (this.sliderAnimate) {
                this.flkty.on('settle', () => this.sliderSettle());
            }

            if (this.setMinHeightFlag || this.multipleSlides) {
                document.addEventListener('theme:resize', this.sliderCallbackEventOnResize);
            }

            if (this.sliderThumbsClick && this.sliderThumbsClick.length) {
                this.sliderThumbsClick.forEach((element) => {
                    element.addEventListener('click', (e) => {
                        e.preventDefault();
                        const slideIndex = [...element.parentElement.children].indexOf(element);
                        this.flkty.select(slideIndex);
                    });
                });
            }

            this.addEventListener('theme:tab:change', this.resetSliderEvent);
        }

        sliderSettle() {
            let animatedItems = this.slideshow.querySelectorAll(`.${classes$D.isSelected} ${selectors$M.aos}`);

            if (this.sliderAnimateOnce) {
                animatedItems = this.slideshow.querySelectorAll(`.${classes$D.isSelected}:not(.${classes$D.aosAnimated}) .${classes$D.aosAnimated}`);
            }

            if (animatedItems.length) {
                animatedItems.forEach((animatedItem) => {
                    animatedItem.classList.add(classes$D.aosAnimate);

                    if (this.sliderAnimateOnce) {
                        animatedItem.closest(`.${classes$D.isSelected}`).classList.add(classes$D.aosAnimated);
                    }
                });
            }
        }

        // Move slides to their initial position
        resetSlider() {
            if (this.slideshow) {
                if (this.flkty && this.flkty.isActive) {
                    this.flkty.select(0, false, true);
                } else {
                    this.slideshow.scrollTo({
                        left: 0,
                        behavior: 'auto',
                    });
                }
            }
        }

        addRemoveSlidesForDevices() {
            this.hasDiffSlidesForMobileDesktop =
                Array.prototype.filter.call(this.slideshowSlides, (slide) => {
                    if (slide.classList.contains('desktop') || slide.classList.contains('mobile')) {
                        return slide;
                    }
                }).length > 0;

            if (!this.hasDiffSlidesForMobileDesktop) {
                return;
            }

            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            let selectorSlides = null;

            if (windowWidth < theme.sizes.small) {
                selectorSlides = `${selectors$M.slide}.mobile, ${selectors$M.slide}:not(.desktop)`;
            } else {
                selectorSlides = `${selectors$M.slide}.desktop, ${selectors$M.slide}:not(.mobile)`;
            }

            this.flkty.options.cellSelector = selectorSlides;
            this.flkty.selectCell(0, false, true);
            this.flkty.reloadCells();
            this.flkty.reposition();
            this.flkty.resize();
            this.slideActions();
        }

        sliderCallbackEvent() {
            this.setMinHeight();

            if (this.multipleSlides) {
                if (this.sliderOptions.prevNextButtons) {
                    this.initArrows();
                }
                this.flkty.resize();
                if (!this.slideshow.classList.contains(classes$D.sliderInitialized)) {
                    this.flkty.select(0);
                }
            }
        }

        slideActions(changeEvent = false) {
            const currentSlide = this.slideshow.querySelector(`.${classes$D.isSelected}`);
            const currentSlideTextColor = currentSlide.getAttribute(attributes$a.slideTextColor);
            const currentSlideLink = currentSlide.querySelector(selectors$M.link);
            const buttons = this.slideshow.querySelectorAll(`${selectors$M.slide} a, ${selectors$M.slide} button`);

            if (document.body.classList.contains(classes$D.focused) && currentSlideLink && this.sliderOptions.groupCells && changeEvent) {
                currentSlideLink.focus();
            }

            if (buttons.length) {
                buttons.forEach((button) => {
                    const slide = button.closest(selectors$M.slide);
                    if (slide) {
                        const tabIndex = slide.classList.contains(classes$D.isSelected) ? 0 : -1;
                        button.setAttribute('tabindex', tabIndex);
                    }
                });
            }

            if (currentSlideTextColor !== 'rgba(0,0,0,0)' && currentSlideTextColor !== '') {
                this.slideshow.style.setProperty('--text', currentSlideTextColor);
            }

            this.setMinHeight();

            if (this.sliderAnimate) {
                let animatedItems = this.slideshow.querySelectorAll(`.${classes$D.isSelected} .${classes$D.aosAnimate}`);
                if (this.sliderAnimateOnce) {
                    animatedItems = this.slideshow.querySelectorAll(`.${classes$D.isSelected}:not(.${classes$D.aosAnimated}) .${classes$D.aosAnimate}`);
                }
                if (animatedItems.length) {
                    animatedItems.forEach((animatedItem) => {
                        animatedItem.classList.remove(classes$D.aosAnimate);
                        if (this.sliderAnimateOnce) {
                            animatedItem.classList.add(classes$D.aosAnimated);
                        }
                    });
                }
            }

            if (this.sliderThumbs && this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && currentSlide.hasAttribute(attributes$a.slideIndex)) {
                const slideIndex = parseInt(currentSlide.getAttribute(attributes$a.slideIndex));
                const currentThumb = this.querySelector(`${selectors$M.sliderThumb}.${classes$D.isSelected}`);
                if (currentThumb) {
                    currentThumb.classList.remove(classes$D.isSelected);
                }
                this.sliderThumbs[slideIndex].classList.add(classes$D.isSelected);
            }
        }

        setMinHeight() {
            if (!this.setMinHeightFlag) return;

            this.slideshowSlides.forEach((element) => {
                const slideImageImg = element.querySelector(selectors$M.slideshowSlideImg);
                let slideAspectRatio = '';
                if (slideImageImg && slideImageImg.hasAttribute(attributes$a.aspectRatio)) {
                    slideAspectRatio = slideImageImg.getAttribute(attributes$a.aspectRatio);
                }

                let slideTextContentHeight = 0;
                let getMargin = 0;
                const slideTextContent = element.querySelector(selectors$M.heroContent);
                if (slideTextContent) {
                    const getMarginTop = parseInt(window.getComputedStyle(slideTextContent).marginTop);
                    const getMarginBottom = parseInt(window.getComputedStyle(slideTextContent).marginBottom);
                    getMargin = getMarginTop + getMarginBottom;
                    slideTextContentHeight = slideTextContent.offsetHeight + getMargin;
                }

                const slideWidth = parseInt(getComputedStyle(element, null).width.replace('px', ''));
                let slideHeight = parseInt(slideWidth / slideAspectRatio) || 0;
                const isCurrentSlide = element.classList.contains(classes$D.isSelected);

                if (slideTextContentHeight > slideHeight) {
                    slideHeight = slideTextContentHeight;
                }

                const minHeightValue = `calc(${slideHeight}px + var(--header-padding))`;
                element.style.setProperty('min-height', minHeightValue);
                const heroContentWrapper = element.querySelector(selectors$M.heroContentWrapper);
                if (heroContentWrapper) {
                    heroContentWrapper.style.setProperty('min-height', minHeightValue);
                }
                if (isCurrentSlide) {
                    this.slideshow.parentElement.style.setProperty('min-height', minHeightValue);
                }
            });
        }

        positionArrows() {


            if (this.slideshow.hasAttribute(attributes$a.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                
                const itemImage = this.slideshow.querySelector(selectors$M.collectionImage) || this.slideshow.querySelector(selectors$M.productItemImage) || this.slideshow.querySelector(selectors$M.columnImage) || this.slideshow.querySelector(selectors$M.categoryNavigatorCardImage);                console.log("🚀 ~ CategorySlider ~ positionArrows ~ itemImage:", itemImage)

                // Prevent 'clientHeight' of null error if no image
                if (!itemImage) return;

                this.slideshow.querySelector(selectors$M.flickityPrevArrow).style.top = itemImage.clientHeight / 2 + 'px';
                this.slideshow.querySelector(selectors$M.flickityNextArrow).style.top = itemImage.clientHeight / 2 + 'px';
            }
        }

        initArrows() {
            if (!this.multipleSlides) return;
            const slidesNumberCustom = parseInt(this.slideshow.getAttribute(attributes$a.slidesLargeDesktop));
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const desktopSlides = this.slideshow.hasAttribute(attributes$a.slidesDesktop) ? parseInt(this.slideshow.getAttribute(attributes$a.slidesDesktop)) : 3;
            const tabletSlides = this.slideshow.hasAttribute(attributes$a.slidesTabletDesktop) ? parseInt(this.slideshow.getAttribute(attributes$a.slidesTabletDesktop)) : 2;
            const mobileSlides = this.slideshow.hasAttribute(attributes$a.slidesMobileDesktop) ? parseInt(this.slideshow.getAttribute(attributes$a.slidesMobileDesktop)) : 1;
            const largeDesktopCheck = windowWidth > 1339 && this.slideshowSlides.length > slidesNumberCustom;
            const desktopCheck = windowWidth <= 1339 && windowWidth > 1023 && this.slideshowSlides.length > desktopSlides;
            const tabletCheck = windowWidth <= 1023 && windowWidth > 749 && this.slideshowSlides.length > tabletSlides;
            const mobileCheck = windowWidth <= 749 && this.slideshowSlides.length > mobileSlides;
            const flag = Boolean(largeDesktopCheck || desktopCheck || tabletCheck || mobileCheck);
            this.slideshow.classList.toggle(classes$D.sliderArrowsHidden, !flag);
            this.slideshow.classList.toggle(classes$D.sliderInitialized, flag);
        }

        equalizeHeight() {
            themeVendor.Flickity.prototype._createResizeClass = function () {
                requestAnimationFrame(() => {
                    this.element.classList.add(classes$D.flickityResize);
                });
            };

            this.flkty._createResizeClass();

            const resize = themeVendor.Flickity.prototype.resize;
            themeVendor.Flickity.prototype.resize = function () {
                this.element.classList.remove(classes$D.flickityResize);
                this.element.classList.add(classes$D.flickityResizing);
                resize.call(this);
                requestAnimationFrame(() => {
                    this.element.classList.add(classes$D.flickityResize);
                    this.element.classList.remove(classes$D.flickityResizing);
                });
            };
        }

        onUnload() {
            if (this.setMinHeightFlag || this.multipleSlides) {
                document.removeEventListener('theme:resize', this.sliderCallbackEventOnResize);
            }

            if (this.slideshow && this.flkty) {
                this.flkty.options.watchCSS = false;
                this.flkty.destroy();
            }

            this.removeEventListener('theme:tab:change', this.resetSliderEvent);

            document.removeEventListener('theme:resize', this.addRemoveSlidesForDevicesOnResize);
        }

        onBlockSelect(evt) {
            if (!this.slideshow) return;
            // Ignore the cloned version
            const slide = this.slideshow.querySelector(`[${selectors$M.slideValue}="${evt.detail.blockId}"]`);

            if (!slide) return;
            let slideIndex = parseInt(slide.getAttribute(attributes$a.slideIndex));

            if (this.multipleSlides && !this.slideshow.classList.contains(classes$D.sliderInitialized)) {
                slideIndex = 0;
            }

            this.slideshow.classList.add(classes$D.isSelected);

            // Go to selected slide, pause autoplay
            if (this.flkty && this.slideshow.classList.contains(classes$D.flickityEnabled)) {
                this.flkty.selectCell(slideIndex);
                this.flkty.stopPlayer();
            }
        }

        onBlockDeselect() {
            if (!this.slideshow) return;
            this.slideshow.classList.remove(classes$D.isSelected);

            if (this.flkty && this.sliderOptions.hasOwnProperty('autoPlay') && this.sliderOptions.autoPlay) {
                this.flkty.playPlayer();
            }
        }


    }

    customElements.define('category-slider', CategorySlider);

}
